import {mutationTypes} from '@/core/constants'

export default {

    [mutationTypes.SERVICO_ATENDIMENTO.SET_FILTROS_BUSCA_TODOS_SERVICOS_ATENDIMENTO](state, filtros) {
        state.resultadoBuscaTodosServicosAtendimento.filtros = filtros
    },

    [mutationTypes.SERVICO_ATENDIMENTO.SET_PAGINACAO_BUSCA_TODOS_SERVICOS_ATENDIMENTO](state, paginacao) {
        state.resultadoBuscaTodosServicosAtendimento.paginacao = paginacao
    },

    [mutationTypes.SERVICO_ATENDIMENTO.RESETA_PAGE_SERVICO_ATENDIMENTO](state) {
        state.resultadoBuscaTodosServicosAtendimento.paginacao.page = 1
    },
}